export default "__VITE_ASSET__f459a9a6__"